import HeroSection from '../pageComponents/home/HeroSection';
import KeyFeaturesSection from '../pageComponents/home/KeyFeaturesSection';
import CloudAgentsSection from '../pageComponents/home/CloudAgentsSection';
import PromptSection from '../pageComponents/home/PromptSection';
import WayfinderProBanner from '../pageComponents/home/WayfinderProBanner';
import SignUpBanner from '../components/SignUpBanner';

function HomePage() {
  return (
    <>
      <HeroSection />
      <CloudAgentsSection />
      <KeyFeaturesSection />
      <PromptSection />
      <WayfinderProBanner />
      <SignUpBanner />
    </>
  );
}

export default HomePage;
